// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"435":"90243cc9","448":"9cfb5b59"}[chunkId] + ".css";
};